import { localStore } from '@/_utils/localstore'

export class Filter {
  private filterKey: string
  constructor(filterKey: string = 'filter_info') {
    this.filterKey = filterKey
  }

  public save(value): void {
    localStore.setItem(this.filterKey, JSON.stringify(value))
  }

  public get(defaultVal = ''): string {
    const value = JSON.parse(localStore.getItem(this.filterKey) as string)
    if (typeof value !== 'object') {
      return value === '' ? defaultVal : value
    }

    return value || defaultVal
  }

  public clear(): void {
    localStore.removeItem(this.filterKey)
  }
}
